<div class="app-container">
  <app-header class="header"></app-header>
  <div class="main">
    <app-sidebar [items]="navItems" class="sidebar"></app-sidebar>
    <div class="content-container">
      <div class="content-header">
        <div class="flex flex-between">
          <app-breadcrumbs
            class="breadcrumbs"></app-breadcrumbs>
          <div class="flex flex-between align-content-center" *ngIf="showFilterButtons()">
            <div style="margin-right: 16px" [ngStyle]="{'width': '16px', 'cursor': 'pointer'}" [pTooltip]="tooltipReset" (click)="resetFilter()"><med-icon-history></med-icon-history></div>
            <div class="h7-heading">Фільтр</div>
            <div class="h7-heading black-30" style="margin-left: 10px; margin-right: 10px">{{filterService.filtersCount(currentPath())}}</div>
            <div>
              <med-icon-filter [ngStyle]="{'width': '16px', 'cursor': 'pointer'}" (click)="showFilter()"></med-icon-filter>
            </div>
          </div>
          <ng-template #tooltipReset>
            <div class="flex items-center h10-text">
              Скинути
            </div>
          </ng-template>
        </div>
        <div *ngIf="filterService.suppliesPageHasFilters() && isPage('supplies')" class="flex gap-1" style="align-items: center">
          <div class="flex h10-text">Фільтри:</div>
          <med-bubble
            [styleClass]="''"
            *ngFor="let item of filterService.supplies.mnn; trackBy: trackByIndex"
            [visibleCloseBtn]="true" (click)="deleteSuppliesFilterItem(filterService.supplies.mnn, item)">
            {{ item }}
          </med-bubble>
          <med-bubble
            [styleClass]="''"
            *ngFor="let item of filterService.supplies.direction; trackBy: trackByIndex"
            [visibleCloseBtn]="true" (click)="deleteSuppliesFilterItem(filterService.supplies.direction, item)">
            {{ getDirectionLabel(item) }}
          </med-bubble>
          <med-bubble *ngIf="filterService.supplies.supplier.length && filterService.supplies.supplier[0]"
            [styleClass]="''"
            [visibleCloseBtn]="true" (click)="deleteSuppliesFilterItem(filterService.supplies.supplier, filterService.supplies.supplier[0])">
            {{ filterService.supplies.supplier[0] }}
          </med-bubble>
          <med-bubble
            [styleClass]="''"
            *ngFor="let item of filterService.supplies.subDirection; trackBy: trackByIndex"
            [visibleCloseBtn]="true" (click)="deleteSuppliesFilterItem(filterService.supplies.subDirection, item)">
            {{ item }}
          </med-bubble>
          <med-bubble
            [styleClass]="''"
            *ngFor="let item of filterService.supplies.status; trackBy: trackByIndex"
            [visibleCloseBtn]="true" (click)="deleteSuppliesFilterItem(filterService.supplies.status, item)">
            {{ item }}
          </med-bubble>
          <med-bubble *ngIf="filterService.supplies.agreementNum.length"
            [styleClass]="''"
            [visibleCloseBtn]="true" (click)="deleteSuppliesFilterItem(filterService.supplies.agreementNum, filterService.supplies.agreementNum[0])">
            {{ filterService.supplies.agreementNum[0] }}
          </med-bubble>
          <med-bubble
            [styleClass]="''"
            *ngFor="let item of filterService.supplies.warehouse; trackBy: trackByIndex"
            [visibleCloseBtn]="true" (click)="deleteSuppliesFilterItem(filterService.supplies.warehouse, item)">
            {{ item }}
          </med-bubble>
          <med-bubble *ngIf="filterService.supplies.actualDate && filterService.supplies.actualDate.length"
            [styleClass]="''"
            [visibleCloseBtn]="true" (click)="deleteFilterItemDate('actualDate')">
            {{ filterService.supplies.actualDate[0] | date: 'dd.MM.yyyy'}} -
            {{ filterService.supplies.actualDate[1] | date: 'dd.MM.yyyy'}}
          </med-bubble>
          <med-bubble *ngIf="filterService.supplies.expectedDate && filterService.supplies.expectedDate.length"
            [styleClass]="''"
            [visibleCloseBtn]="true" (click)="deleteFilterItemDate('expectedDate')">
            {{ filterService.supplies.expectedDate[0] | date: 'dd.MM.yyyy' }} -
            {{ filterService.supplies.expectedDate[1] | date: 'dd.MM.yyyy' }}
          </med-bubble>
        </div>
      </div>

      <div *ngIf="filterService.reservesPageHasFilters() && isPage('reserves') && !filterService.goodSpecificationsShowed" class="flex gap-1" style="align-items: center">
        <div class="flex h10-text">Фільтри:</div>
        <med-bubble *ngIf="filterService.reserves.lovId.length"
                    [styleClass]="''"
                    [visibleCloseBtn]="true" (click)="deleteReservesFilterItem(filterService.reserves.lovId, filterService.reserves.lovId[0])">
          {{ filterService.reserves.lovId[0] }}
        </med-bubble>
        <med-bubble *ngIf="filterService.reserves.mnnId.length"
                    [styleClass]="''"
                    [visibleCloseBtn]="true" (click)="deleteReservesFilterItem(filterService.reserves.mnnId, filterService.reserves.mnnId[0])">
          {{ filterService.reserves.mnnId[0] }}
        </med-bubble>
        <med-bubble *ngFor="let item of filterService.reserves.direction; trackBy: trackByIndex"
                    [styleClass]="''"
                    [visibleCloseBtn]="true" (click)="deleteReservesFilterItem(filterService.reserves.direction, item)">
          {{ getDirectionLabel(item) }}
        </med-bubble>
        <med-bubble *ngFor="let item of filterService.reserves.mnn; trackBy: trackByIndex"
                    [styleClass]="''"
                    [visibleCloseBtn]="true" (click)="deleteReservesFilterItem(filterService.reserves.mnn, item)">
          {{ item }}
        </med-bubble>
        <med-bubble *ngIf="filterService.reserves.dosage.length && filterService.reserves.dosage[0]"
                    [styleClass]="''"
                    [visibleCloseBtn]="true" (click)="deleteReservesFilterItem(filterService.reserves.dosage, filterService.reserves.dosage[0])">
          {{ filterService.reserves.dosage[0] }}
        </med-bubble>
        <med-bubble *ngIf="filterService.reserves.measure.length && filterService.reserves.measure[0]"
                    [styleClass]="''"
                    [visibleCloseBtn]="true" (click)="deleteReservesFilterItem(filterService.reserves.measure, filterService.reserves.measure[0])">
          {{ filterService.reserves.measure[0] }}
        </med-bubble>
        <med-bubble *ngIf="filterService.reserves.reject.length"
                    [styleClass]="''"
                    [visibleCloseBtn]="true" (click)="deleteReservesFilterItem(filterService.reserves.reject, filterService.reserves.reject[0])">
          {{ filterService.reserves.reject[0] }}
        </med-bubble>

        <med-bubble *ngIf="filterService.reserves.availability.length && filterService.reserves.availability[0]"
                    [styleClass]="''"
                    [visibleCloseBtn]="true" (click)="deleteReservesFilterItem(filterService.reserves.availability, filterService.reserves.availability[0])">
          {{ filterService.reserves.availability[0] }}
        </med-bubble>
        <med-bubble *ngIf="filterService.reserves.documents.length"
                    [styleClass]="''"
                    [visibleCloseBtn]="true" (click)="deleteReservesFilterItem(filterService.reserves.documents, filterService.reserves.documents[0])">
          {{ filterService.reserves.documents[0] }}
        </med-bubble>
        <med-bubble *ngIf="filterService.reserves.subDirection.length && filterService.reserves.subDirection[0]"
                    [styleClass]="''"
                    [visibleCloseBtn]="true" (click)="deleteReservesFilterItem(filterService.reserves.subDirection, filterService.reserves.subDirection[0])">
          {{ filterService.reserves.subDirection[0] }}
        </med-bubble>
        <med-bubble *ngIf="filterService.reserves.controlDate && filterService.reserves.controlDate.length"
                    [styleClass]="''"
                    [visibleCloseBtn]="true" (click)="deleteFilterItemDate('controlDate')">
          {{ filterService.reserves.controlDate[0] | date: 'dd.MM.yyyy' }} -
          {{ filterService.reserves.controlDate[1] | date: 'dd.MM.yyyy' }}
        </med-bubble>
      </div>

      <div class="content">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</div>

<med-notification
        position="top-right"
        [lifeTime]="10000"
        [closable]="true"
></med-notification>

<med-tooltip-content></med-tooltip-content>

<med-popup-content></med-popup-content>
